<template>
<div class="container p-l-r-0 container-shadow" >
   <!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="#">
            {{workspace.type}}
        </a></li>
    <li class="breadcrumb-item active" aria-current="page">Library</li>
  </ol>
</nav> -->
    <!-- <div class="row select-user-area " >
        <div class="col-sm-2 col-md-2 col-xs-12">
            <img src="../../../assets/images/person-15.png" class="img-responsive head-person-img">
        </div>
        <div class="col-sm-3 col-md-3 col-xs-12 namehere">
            <h5>NAME HERE</h5>
            <p class="font-12">Services valid till 20 2020</p>
        </div>
    </div> -->
    <div class="row">
     <UserProfile></UserProfile>
   </div>
    <div class="row content-holder">
        <div class="col-sm-3 col-md-3   col-xs-3" v-if="workspace.activity_type != 'zoho-dashboard'" style="background-color: white;padding-bottom: 20px;">
            <LeftNav :type="menu_activate" />
        </div>
        <div class="col-sm-9 col-md-9 col-xs-9" v-if="workspace.activity_type != 'zoho-dashboard'" style="background-color: #eaeaea;border:10px solid white">
            <MainActivity :workspaceData="workspace"></MainActivity>
        </div>
        
        <div class="col-sm-12 col-md-12 col-xs-12 zohodashboar_box" v-if="workspace.activity_type == 'zoho-dashboard'" style="background-color: #eaeaea;border:10px solid white">
            <MainActivity :workspaceData="workspace"></MainActivity>
        </div>
    </div>
</div>
</template>

<script>
import LeftNav from "../layouts/leftNav.vue"
import MainActivity from "./activity.vue"
// import activity from '../../services/activity'
import Pusher from 'pusher-js'
import UserProfile from "../layouts/profile-header.vue"
export default {
    name: 'user-row',
    data(){
       return {
            workspace:{},
            pusher: null,
            channel: null,
            menu_activate:''
       }
    },
    components: {
        LeftNav,
        MainActivity,
        UserProfile
    },
    mounted(){
       if(this.$route.params){
          this.workspace=this.$route.params
          let menu_act= this.workspace.id.split('-');
          this.menu_activate=menu_act[1];
       }
       
    },
    methods:{
        ShowAlert(data){
            console.log(data);
        },
       
    },
     created(){
            this.pusher = new Pusher('0c25422f2cffb67b5ac7', {
                encrypted: true,
                cluster: 'ap2'
            })
            let that = this
            this.channel = this.pusher.subscribe('subscription_created')
            this.channel.bind('subscription_created', function (data) {
                that.$emit('subscription_created_user', data)
            })
            this.$on('subscription_created_user', function (receiveData) {
               this.ShowAlert(receiveData)
            })
    },
}
</script>

<style scoped>
@import '../../../assets/css/dashboard.css';
</style>
